/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import _ from "lodash";
import { GET_ALL_MODULES, SET_NO_MODULE, SET_SELECTED_MODULE, SET_AVAILABLE_MODULES, SET_SELECTED_MODULES_LIST, SET_FILTERED_MODULES, RESET_MODULES } from "./types";

const initialState: any = {
  modules: [],
  noModule: true,
  pagination: {
    pageNumber: 1,
    pageSize: 10,
    totalCount: 0,
  },
  filteredModules: [],
  selectedModule: {},
  availableModules: [],
  selectedModulesList: [],
};

export const moduleReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_ALL_MODULES:
      // const allModulesList = _.union([...state.modules, ...action.modules], 'id');
      return {
        ...state,
        noModule: action.noModule,
        pagination: action.pagination,
        modules: action.modules || [],
        selectedModule: action.selectedModule || {},
      };
    case SET_FILTERED_MODULES:
      return {
        ...state,
        filteredModules: action.filteredModules,
      };
    case SET_NO_MODULE:
      return {
        ...state,
        noModules: action.noModules,
      };
    case SET_SELECTED_MODULE:
      return {
        ...state,
        selectedModule: action.selectedModule,
      };
    case SET_AVAILABLE_MODULES:
      const allModules = _.union([...state.availableModules, ...action.availableModules], 'id');
      return {
        ...state,
        availableModules: allModules || [],
      };
    case SET_SELECTED_MODULES_LIST:
      return {
        ...state,
        selectedModulesList: action.selectedModulesList,
      };
    case RESET_MODULES:
      return {
        ...state,
        modules: [],
        selectedModule: {},
      };
    default:
      return state;
  }
};
